import { render, staticRenderFns } from "./UpdatePaymentMethod.vue?vue&type=template&id=5b2179de&"
import script from "./UpdatePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./UpdatePaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePaymentMethod.vue?vue&type=style&index=0&id=5b2179de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports